import { MatDialog } from '@angular/material/dialog';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private dialog: MatDialog) { }

  private remappedErrorMessages: { key: string, message: string }[] = [
    { key: "MomentDateAdapter: Cannot format invalid date.", message: null },
    { key: "FirebaseError: [code=permission-denied]: Missing or insufficient permissions.", message: null }];

  handleError(error) {
    console.error(error);
    window.onerror(null, null, null, null, error);

    const messageKey: string = error.message ? error.message.toString().trim() : null;
    const remappedError = this.remappedErrorMessages.find((item) => messageKey && messageKey.indexOf(item.key) >= 0);

    if (remappedError) {
      if (remappedError.message) {
        alert(remappedError.message);
      } else {
        console.warn("This error has been muted.", error);
      }
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: error
      });
    }

    throw error;
  }

}
